import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

interface HeroProps {
  title?: string;
  description?: string;
  showScrollButton?: boolean;
  scrollTargetId?: string;
}

export const Hero = ({ 
  title = "Gewerbefläche mieten - Alle Portale in Deutschland",
  description = "Büro, Lager oder Laden: Vergleichen Sie Immobilienportale nach Standort und Flächentyp und finden Sie passende Anbieter für Ihr Unternehmen.",
  showScrollButton = true,
  scrollTargetId = "plattformen"
}: HeroProps) => {
  const handleScroll = () => {
    const el = document.getElementById(scrollTargetId);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return <section className="relative bg-gradient-to-br from-primary via-primary to-primary/90 py-16 px-4 sm:px-6 lg:px-8 min-h-[260px]" aria-label="Seitenüberschrift" id="main-content">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground mb-4 tracking-tight">
            {title}
          </h1>
          <p className="text-lg sm:text-xl text-primary-foreground/90 max-w-3xl mx-auto leading-relaxed">
            {description}
          </p>
          {showScrollButton && (
            <Button
              variant="secondary"
              size="lg"
              className="mt-6 gap-2"
              onClick={handleScroll}
            >
              Zu den Plattformen
              <ArrowDown className="w-4 h-4" />
            </Button>
          )}
        </div>
      </div>
    </section>;
};